"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Icon_1 = require("../../Icon");
var Button_1 = require("../../Button");
var stylesImport = require("./DocumentCard.scss");
var styles = stylesImport;
var DocumentCardActions = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardActions, _super);
    function DocumentCardActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardActions.prototype.render = function () {
        var _a = this.props, actions = _a.actions, views = _a.views;
        return (React.createElement("div", { className: Utilities_1.css('ms-DocumentCardActions', styles.actions) },
            actions && actions.map(function (action, index) {
                return (React.createElement("div", { className: Utilities_1.css('ms-DocumentCardActions-action', styles.action), key: index },
                    React.createElement(Button_1.IconButton, tslib_1.__assign({}, action))));
            }),
            views > 0 && (React.createElement("div", { className: Utilities_1.css('ms-DocumentCardActions-views', styles.views) },
                React.createElement(Icon_1.Icon, { iconName: 'View' }),
                views))));
    };
    return DocumentCardActions;
}(Utilities_1.BaseComponent));
exports.DocumentCardActions = DocumentCardActions;
//# sourceMappingURL=DocumentCardActions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/DocumentCard/DocumentCardActions.js
// module id = 1526
// module chunks = 0